import { render, staticRenderFns } from "./WalmartLogin.vue?vue&type=template&id=34bb0c8a&scoped=true"
import script from "./WalmartLogin.vue?vue&type=script&lang=js"
export * from "./WalmartLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bb0c8a",
  null
  
)

export default component.exports